import React, { useEffect } from 'react';
import { CheckIcon } from 'lucide-react';
type MultiSelectInputProps = {
  options: string[];
  value: string[];
  onChange: (v: string[]) => void;
  single?: boolean;
};
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
export function MultiSelectInput({
  options,
  value,
  onChange,
  single
}: MultiSelectInputProps) {
  const toggle = (opt: string) => {
    if (single) {
      if (value.includes(opt)) {
        onChange([]);
      } else {
        onChange([opt]);
      }
      return;
    }
    if (value.includes(opt)) {
      onChange(value.filter(v => v !== opt));
    } else {
      onChange([...value, opt]);
    }
  };
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) return;
      const key = e.key.toUpperCase();
      const idx = LETTERS.indexOf(key);
      if (idx >= 0 && idx < options.length) {
        e.preventDefault();
        toggle(options[idx]);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [options, value, single]);
  return <div className="flex flex-col gap-3" data-id="element-12">
      <p className="text-neutral-500 text-sm" data-id="element-13">
        {single ? 'Choose one' : 'Choose as many as you like'}
      </p>
      {options.map((opt, i) => {
      const selected = value.includes(opt);
      return <button key={opt} type="button" onClick={() => toggle(opt)} className={`group flex items-center gap-3 sm:gap-4 text-left px-3 sm:px-4 py-3 rounded-lg border transition-all ${selected ? 'bg-white text-black border-white' : 'bg-white/[0.03] text-white border-white/15 hover:border-white/50 hover:bg-white/[0.06]'}`} data-id="element-14">
            <span className={`inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 text-[10px] sm:text-xs font-semibold rounded border shrink-0 ${selected ? 'border-black/30 text-black bg-white' : 'border-white/30 text-neutral-300'}`} data-id="element-15">
              {LETTERS[i]}
            </span>
            <span className="text-sm sm:text-lg flex-1 leading-snug" data-id="element-16">
              {opt}
            </span>
            {selected && <CheckIcon className="w-4 h-4 shrink-0" strokeWidth={3} data-id="element-17" />}
          </button>;
    })}
    </div>;
}